import { IGlobalState } from '../reducers';
import { IState } from '../reducers/locations';

export const getCenters = (state: IGlobalState): IState['centers'] => state.locations.centers;
export const getCurrentLocation = (state: IGlobalState): IState['currentLocation'] => state.locations.currentLocation;
